import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

// VUEX Store
export default new Vuex.Store({
  state: {
    onSignUp: false,
    settings: {
      logoUrl: '',
      theme: '',
      clubName: '',
      phone: '',
      hasCustomSkin: '',
    },
    logoError: false,
    logoErrorType: '',
    timezones: [],
    selectedTimezone: '',
    themes: [],
    contacts: [],
  },
  actions: {
    async GET_CLIENT_SETTINGS(context, payload) {
      try {
        const url = '/api/settings/client-settings';
        const request = new Request(url, {
          method: 'GET',
          credentials: 'same-origin',
        });

        const response = await fetch(request);
        const json = await response.json();

        context.commit('SET_CLIENT_SETTINGS', json.data);
      } catch (error) {
        console.error(error);
      }
    },

    async UPDATE_SETTINGS(context, payload) {
      try {
        const url = '/api/settings/client-settings';
        const request = new Request(url, {
          method: 'POST',
          credentials: 'same-origin',
          body: JSON.stringify({
            facebook: payload.facebook,
            twitter: payload.twitter,
            website: payload.website,
            instagram_handle: payload.instagram_handle,
            youtube_account: payload.youtube_account,
            tiktok_handle: payload.tiktok_handle,
            'club-name': payload.clubName,
            phone: payload.phone,
            'listing-description': payload.description,
          }),
        });

        const response = await fetch(request);
        const json = await response.json();

        context.commit('SET_CLIENT_SETTINGS', json.data);
      } catch (error) {
        console.error(error);
      }
    },

    async GET_THEMES(context, payload) {
      try {
        const url = '/api/settings/themes';
        const request = new Request(url, {
          method: 'GET',
          credentials: 'same-origin',
        });

        const response = await fetch(request);
        const json = await response.json();

        context.commit('SET_THEMES', json.data);
      } catch (error) {
        console.error(error);
      }
    },

    async UPLOAD_LOGO(context, payload) {
      context.commit('SET_LOGO_ERROR', false);
      context.commit('SET_LOGO_ERROR_TYPE', '');

      try {
        const url = '/api/settings/logo';
        const request = new Request(url, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': payload.type },
          body: payload,
        });

        const response = await fetch(request);
        const json = await response.json();

        if (json.data.error == 'size') {
          context.commit('SET_LOGO_ERROR', true);
          context.commit('SET_LOGO_ERROR_TYPE', 'size');
        } else if (json.data.error == 'type') {
          context.commit('SET_LOGO_ERROR', true);
          context.commit('SET_LOGO_ERROR_TYPE', 'type');
        } else {
          context.commit('SET_CLIENT_LOGO_URL', json.data);
        }
      } catch (error) {
        console.error(error);
      }
    },

    async UPDATE_THEME(context, payload) {
      try {
        const url = '/api/settings/theme';
        const request = new Request(url, {
          method: 'POST',
          credentials: 'same-origin',
          body: JSON.stringify({
            skin: payload,
          }),
        });

        const response = await fetch(request);
        const json = await response.json();

        context.commit('SET_SELECTED_CLIENT_THEME', json.data);
      } catch (error) {
        console.error(error);
      }
    },

    UPDATE_SIGNUP_STATE(context, payload) {
      context.commit('SET_SIGNUP_STATE', payload);
    },

    UPDATE_HAS_CUSTOM_SKIN_STATE(context, payload) {
      context.commit('SET_HAS_CUSTOM_SKIN_STATE', payload);
    },

    async GET_TIMEZONES(context, payload) {
      try {
        const url = '/api/timezones';
        const request = new Request(url, {
          method: 'GET',
          credentials: 'same-origin',
        });

        const response = await fetch(request);
        const json = await response.json();

        context.commit('SET_AVAILABLE_TIMEZONES', json.data);
      } catch (error) {
        console.error(error);
      }
    },

    async GET_SELECTED_TIMEZONE(context, payload) {
      try {
        const url = '/api/client/timezone';
        const request = new Request(url, {
          method: 'GET',
          credentials: 'same-origin',
        });

        const response = await fetch(request);
        const json = await response.json();

        context.commit('SET_TIMEZONE', json.data);
      } catch (error) {
        console.error(error);
      }
    },

    async SET_SELECTED_TIMEZONE(context, payload) {
      try {
        const url = '/api/client/timezone';
        const request = new Request(url, {
          method: 'POST',
          credentials: 'same-origin',
          body: JSON.stringify({ timezone: payload }),
        });

        const response = await fetch(request);
        const json = await response.json();

        context.commit('SET_TIMEZONE', json.data);
      } catch (error) {
        console.error(error);
      }
    },

    async RESET_CLIENT_STRIPE_SUBSCRIPTION_ID(context, payload) {
      try {
        const url = '/rest/v1/client/settings/reset-stripe-subscription';
        const request = new Request(url, {
          method: 'POST',
          credentials: 'same-origin',
        });

        await fetch(request);
      } catch (error) {
        console.error(error);
      }
    },

    async RESET_SETUP_FEES(context, payload) {
      try {
        const url = '/api/settings/reset-setup-fees';
        const request = new Request(url, {
          method: 'POST',
          credentials: 'same-origin',
        });

        const response = await fetch(request);
        const json = await response.json();

        // context.commit('SET_TIMEZONE', json.data);
      } catch (error) {
        console.error(error);
      }
    },

    async CREATE_SETUP_FEES(context, payload) {
      // const childrenGetter = context.getters.contacts.slice(0, 10);
      const children = payload.map((contact) => contact.childId);

      try {
        const url = '/api/orders/order/create';
        const request = new Request(url, {
          method: 'POST',
          credentials: 'same-origin',
          body: JSON.stringify({
            children,
            orderItemType: 'setup-fee',
          }),
        });

        const response = await fetch(request);
        const json = await response.json();

        // context.commit('SET_TIMEZONE', json.data);
      } catch (error) {
        console.error(error);
      }
    },

    async GET_ALL_CONTACTS(context, payload) {
      const url = '/api/contacts/all-contacts';
      const request = new Request(url, {
        method: 'GET',
        credentials: 'same-origin',
      });

      try {
        const contactsResponse = await fetch(request);
        const json = await contactsResponse.json();

        return context.commit('SET_CONTACTS_DATA', json.data);
      } catch (err) {
        console.error(err);
      }
    },
  },
  mutations: {
    SET_CLIENT_SETTINGS(state, payload) {
      // making sure null values are accounted for.
      for (const setting in payload) {
        if (!payload[setting]) {
          payload[setting] = '';
        }
      }
      state.settings = payload;
    },

    SET_THEMES(state, payload) {
      state.themes = payload;
    },

    SET_CLIENT_LOGO_URL(state, payload) {
      state.settings.logoUrl = `${payload}?t=${new Date().getTime()}`;
    },

    SET_LOGO_ERROR(state, payload) {
      state.logoError = payload;
    },

    SET_LOGO_ERROR_TYPE(state, payload) {
      state.logoErrorType = payload;
    },

    SET_SELECTED_CLIENT_THEME(state, payload) {
      state.settings.theme = payload;
    },

    SET_SIGNUP_STATE(state, payload) {
      state.onSignUp = payload;
    },
    SET_HAS_CUSTOM_SKIN_STATE(state, payload) {
      state.hasCustomSkin = payload;
    },
    SET_AVAILABLE_TIMEZONES(state, payload) {
      state.timezones = payload;
    },
    SET_TIMEZONE(state, payload) {
      state.selectedTimezone = payload;
    },
    SET_CONTACTS_DATA(state, payload) {
      state.contacts = payload;
    },
  },

  getters: {
    settings(state) {
      return state.settings;
    },

    logoUrl(state) {
      return state.settings.logoUrl;
    },

    logoError(state) {
      return state.logoError;
    },

    logoErrorType(state) {
      return state.logoErrorType;
    },

    themes(state) {
      return state.themes;
    },

    selectedTheme(state) {
      return state.settings.theme;
    },
    onSignUp(state) {
      return state.onSignUp;
    },
    hasCustomSkin(state) {
      return state.hasCustomSkin;
    },
    timezones(state) {
      return state.timezones;
    },
    selectedTimezone(state) {
      return state.selectedTimezone || 'Europe/London';
    },
    contacts(state) {
      return state.contacts;
    },
  },
});
